import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { BillingDashboardResponse } from './types';

export interface UseGetBillingParams {
	month?: number;
	year?: number;
}

export function useGetBilling({ month, year }: UseGetBillingParams = {}) {
	const query = useQuery<BillingDashboardResponse>({
		queryKey: ['billing-dashboard', month, year],

		queryFn: async () => {
			const { data } = await api.get<BillingDashboardResponse>(
				'/invoicing/dashboard',
				{
					params: {
						month,
						year,
					},
				},
			);
			return data;
		},
	});

	return {
		...query,
		data: query.data ?? null,
		landingPageCards: query.data?.landingPageCards ?? [],
		month: query.data?.month,
		year: query.data?.year,
	};
}